import React, { useState } from "react";
import { connect } from "react-redux";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { signUpReducer, mapDispatchToProps } from "./SignUp.store";
import SignUp from "../../library/SignUp/SignUp";

export const SmartSignUp = (props) => {
  const { register, onAuthModalClose } = props;
  const [errorMessage, setErrorMessage] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleRegister = (username, password, acceptedTerms) => {
    const user = {
      acceptedTerms,
      email: username,
      password,
    };
    register(user)
      .then(() => {
        setShowSuccessModal(true);
      })
      .catch((err) => {
        setErrorMessage(err);
      });
  };

  const handleModalClose = () => {
    onAuthModalClose();
  };

  return (
    <SignUp
      errorMessage={errorMessage}
      showSuccessModal={showSuccessModal}
      handleRegister={handleRegister}
      handleModalClose={handleModalClose}
    />
  );
};

export default dynamic(
  "signUpReducer",
  subspaced({
    // We map extra state because we might need to access other stores for data, subspace is self contained.
    mapExtraState: (state) => ({ registerReducer: state.registerReducer }),
  }),
  attachReducer(signUpReducer)
)(connect(null, mapDispatchToProps)(SmartSignUp));
